module.exports = __webpack_public_path__ + "img/Enchantress.fdbed6d2.png";